<!--
 * @Author: your name
 * @Date: 2022-03-08 13:36:56
 * @LastEditTime: 2022-03-09 11:35:47
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\components\client\index.vue
-->
<template>
  <div class="client">
    <div class="client-btn" @click="visible = true">
      <!-- <span class="iconfont icon-kehuduan"></span> -->
      <img src="@/assets/workbench/desktop.png" />
      <div class="text">下载客户端</div>
    </div>
    <a-modal :visible="visible" title="客户端下载" class="client-mask" :footer="null" @cancel="visible = false">
      <span class="choose-word">请选择您当前使用的Catia版本：</span>
      <a-select class="catia-select" v-model="curVersion.version" placeholder="请选择">
        <a-select-option v-for="item in versions" :value="item.version" :key="item.id">{{
          item.version
        }}</a-select-option>
      </a-select>
      <a-button class="download-btn" @click="_download">安装最新版闪设客户端</a-button>
    </a-modal>
  </div>
</template>
<script>
import { getVersions } from '@/api/api'
export default {
  data() {
    return {
      visible: false,
      versions: [],
      curVersion: {}
    }
  },
  mounted() {
    this._getVersions()
  },
  methods: {
    async _getVersions() {
      const { data } = await getVersions({})
      this.versions = data.map((item, index) => ({
        id: index,
        ...item
      }))
      this.curVersion = data[0]
    },
    _download() {
      window.open(this.curVersion.downLoadUrl)
    }
  }
}
</script>
<style lang="less">
.client {
  .client-btn {
    color: #5a607f;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
    img {
      margin-right: 4px;
      width: 12px;
      height: 12px;
    }
    .text {
      height: inherit;
    }
  }
}
.client-mask {
  .ant-modal-title {
    color: #383f69;
    font-size: 16px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
  }
  .ant-modal-content {
    overflow: hidden;
    border-radius: 12px;
    .ant-modal-body {
      text-align: center;
      .ant-modal-close-icon {
        color: #858ebd;
        font-size: 20px;
      }
      .choose-word {
        font-size: 14px;
        color: #3a3f63;
      }
      .catia-select {
        width: 190px;
        border-radius: 6px;
        color: #3a3f63;
        .ant-select-selection {
          border: 1px solid #dae0f2;
        }
      }
      .download-btn {
        height: 32px;
        background: #0593e9;
        border-radius: 4px;
        color: #fff;
        margin: 30px auto;
        border: 0;
      }
    }
  }
}
</style>
